export default __webpack_public_path__ + "static/seadia-bdcd51d3ce96a6665352da158a1bf836.jpg";